<template>
    <div>인증중...</div>
</template>

<script>
    export default {
        name: 'Cafe24InitView',
    };
</script>

<style lang="scss" scoped>

</style>